import Phaser from 'phaser'
import { ContainmentScene } from './ContainmentScene'

export function createGame(parent: string): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: '#070a12',
    transparent: false,
    width: 720,
    height: 820,
    render: {
      antialias: true,
      pixelArt: false,
      roundPixels: false,
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 720,
      height: 820,
    },
    scene: [ContainmentScene],
  })
}
